export default __webpack_public_path__ + "static/media/event-title.0edf7968.png";